import React from 'react';
import { Box, Heading, Text, Container } from '@chakra-ui/react';

export default function AboutPage() {
  return (
    <Container maxW="container.xl" py={8}>
      <Box>
        <Heading as="h1" size="2xl" mb={4}>
          About
        </Heading>
        <Text fontSize="lg">
          This is the About page.
        </Text>
      </Box>
    </Container>
  );
}
